import usePageTitle from "@/hooks/usePageTitle";
import AppLayout from "@/layouts/AppLayout";
import Tabs from "@/components/Tabs";
import { useNavigate, Path } from "@/router";
import { useLocation, useNavigate as useRouterNavigate } from "react-router-dom";
import useTableRowMenu from "@/hooks/useTableRowMenu";
import useFacilitiesQuery from "./_hooks/useFacilitiesQuery";
import FacilitiesTable from "./_components/FacilitiesTable";
import { DOMAIN, PERMISSION, useHasCapabilityBool, useRequireCapability } from "@/hooks/useCapabilities";
import { TableHeading, type TableAction } from "@/components/Table";

export default function FacilitiesPage() {
  useRequireCapability({ domain: DOMAIN.FACILITIES, permission: PERMISSION.viewFacilities });
  usePageTitle("/facilities", "Facilities");
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const routerNavigate = useRouterNavigate();
  const tableProps = useFacilitiesQuery();
  const { Menu, setMenu } = useTableRowMenu();
  const canCreateFacility = useHasCapabilityBool({
    domain: DOMAIN.FACILITIES,
    permission: PERMISSION.createFacilities
  });
  const actions: TableAction[] = canCreateFacility
    ? [
        {
          label: "Create Facility",
          icon: "add",
          testId: "create-facility-button",
          onClick: () => routerNavigate("/facilities/new")
        }
      ]
    : [];

  return (
    <AppLayout bottomBar>
      <Tabs
        tabItems={[{ label: "Facilities", to: "/facilities" as Path }].map(({ label, to }) => ({
          label,
          onClick: () => navigate(to),
          active: (pathname.endsWith("/") ? pathname.slice(0, -1) : pathname) === to
        }))}
      />
      <Menu />
      <div className="w-full">
        {actions.length > 0 ? <TableHeading actions={actions} /> : <div className="pt-6" />}
        <FacilitiesTable
          {...tableProps}
          setMenu={setMenu}
          selectedSectionIds={tableProps.selectedSectionIds}
          setSelectedSectionIds={tableProps.setSelectedSectionIds}
        />
      </div>
    </AppLayout>
  );
}
